// QualificationConfiguration.js

import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

function QualificationConfiguration() {
  const navigate = useNavigate();

  const [qualification, setQualification] = useState({
    name: '',
    type: 'Role'
  });
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (id) {
      setIsEditing(true);
      fetch(`${API_BASE_URL}/qualifications/get_qualifications.php?id=${id}`, { credentials: 'include' })
        .then(response => response.json())
        .then(data => {
          setQualification({
            name: data.name || '',
            type: data.type || 'Role'
          });
        })
        .catch(error => console.error('Error fetching qualification:', error));
    }
  }, [id]);

  const handleChange = e => {
    const { name, value } = e.target;
    setQualification(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = () => {
    const form = document.querySelector('form');
    if (!form.checkValidity()) {
      Swal.fire({ icon: 'warning', text: 'Please fill in all required fields.' });
      return;
    }
    const formData = new FormData();
    formData.append('name', qualification.name);
    formData.append('type', qualification.type);
    if (isEditing) {
      formData.append('id', id);
      formData.append('isUpdate', 1);
    }

    fetch(`${API_BASE_URL}/qualifications/save_qualification.php`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          navigate('/config/qualification-list');
        } else {
          Swal.fire({ icon: 'error', text: 'Failed to save qualification/role: ' + data.message });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        Swal.fire({ icon: 'error', text: 'An error occurred: ' + error.message });
      });
  };

  const handleCancel = () => {
    navigate('/config/qualification-list');
  };

  return (
    <div className='m-2'>
      <h2>Qualification/Role Configuration</h2>
      <Form>
        <Form.Group controlId="name">
          <Form.Label>Name</Form.Label>
          <Form.Control type="text" name="name" value={qualification.name} onChange={handleChange} required />
        </Form.Group>
        <Form.Group controlId="type" className='mt-2'>
          <Form.Label>Type</Form.Label>
          <Form.Control as="select" name="type" value={qualification.type} onChange={handleChange}>
            <option value="Role">Role</option>
            <option value="Qualification">Qualification</option>
            <option value="Others">Others</option>
          </Form.Control>
        </Form.Group>
      </Form>
      <div className='mt-2'>
        <Button variant="primary" className="mr-2" onClick={handleSave}>Save</Button>
        <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
      </div>
    </div>
  );
}

export default QualificationConfiguration;
